export enum HallowDataTestId {
  AlreadyHaveAccountButton = "already-have-account-button",
  AuthContinueButton = "auth-continue-button",
  AuthContinueWithAppleButton = "auth-continue-with-apple-button",
  AuthContinueWithGoogleButton = "auth-continue-with-google-button",
  AuthFirstNameInput = "auth-first-name-input",
  AuthLastNameInput = "auth-last-name-input",
  AuthContinueWithPhoneOrEmailButton = "auth-continue-with-phone-or-email-button",
  AuthContinueWithEmailOrUsernameButton = "auth-continue-with-email-or-username-button",
  AuthSubmitButton = "auth-submit-button",
  AuthUseEmailInsteadButton = "auth-use-email-instead-button",
  AuthUsePasswordInsteadButton = "auth-use-password-instead-button",
  Cart = "cart",
  CartDetailsTrigger = "cart-details-trigger",
  CollectionTitle = "collection-title",
  CommunityTypeTitle = "community-type-title",
  ConsentModalTitle = "consent-modal-title",
  ContentCTAButton = "content-cta-button",
  ContentDescription = "content-description",
  ContentMedium = "content-medium",
  ContentSmall = "content-small",
  ContentTitle = "content-title",
  CreditOrDebitCardEmailInput = "credit-or-debit-card-email-input",
  CreditOrDebitCardNameInput = "credit-or-debit-card-name-input",
  CreditOrDebitCardTrigger = "credit-or-debit-card-trigger",
  DialogPrimaryButton = "dialog-primary-button",
  DownloadBannerHeaderDesktop = "download-banner-header-desktop",
  DownloadBannerHeaderMobile = "download-banner-header-mobile",
  DytDescription = "dyt-description",
  DytToggleGroupItem = "dyt-toggle-group-item",
  DytToggleGroupItemDescription = "dyt-toggle-group-item-description",
  DytToggleGroupItemTitle = "dyt-toggle-group-item-title",
  Errors = "errors",
  GCashTrigger = "gcash-trigger",
  HomeIconFilled = "home-icon-filled",
  Main = "main",
  MenuBar = "menu-bar",
  OnboardingScreenTitle = "onboarding-screen-title",
  OnboardingScreenContinue = "onboarding-screen-continue",
  OnboardingStackCard = "onboarding-stack-card",
  OnboardingStackCardYesButton = "onboarding-stack-card-yes-button",
  OnboardingStackCardNoButton = "onboarding-stack-card-no-button",
  OTPInput = "otp-input",
  PaymentButtonSubmit = "payment-button-submit",
  Payments = "payments",
  PromoCodeInput = "promo-code-input",
  PromoCodeSubmitButton = "promo-code-submit-button",
  PromoCodeTrigger = "promo-code-trigger",
  PromotionalOffer = "promotional-offer",
  SelectDescription = "select-description",
  SelectTrigger = "select-trigger",
  SubmitPaymentButton = "submit-payment-button",
  SubscriptionIcon = "subscription-icon",
  SubscriptionPlanActionButton = "subscription-plan-action-button",
  SubscriptionPlanTitle = "subscription-plan-title",
  SubscribeContinueButton = "subscribe-continue-button",
  TabBar = "tab-bar",
  Tag = "tag",
}
